import { useTranslation } from "next-i18next";
import Icon from "@ui-kit/icons/Icon.web";
import { Badge, ChildBadgeProps } from "@ui-kit/data-display/Badge/Badge";

export const DiscountBadge = ({ isVisible = true }: ChildBadgeProps) => {
  const { t } = useTranslation("purchases");

  const icon = (
    <Icon.Membership
      boxSize={{ base: "element.md", sm: "element.xl" }}
      mr="sm"
      aria-label={t("discount icon")}
    />
  );

  return (
    <Badge
      icon={icon}
      text={t("Discount Available")}
      isVisible={isVisible}
      data-testid="discount-badge"
    />
  );
};
